(() => {
  const bannerRoot = document.querySelector('[data-cookie-consent]');
  const modal = document.querySelector('[data-cookie-modal]');
  if (!bannerRoot || !modal || !window.Shopify?.loadFeatures) return;

  let privacyApi = null;
  let lastFocus = null;

  const closeModal = () => {
    modal.hidden = true;
    document.documentElement.classList.remove('buskins-cookie-modal-open');
    lastFocus?.focus();
  };

  const updateOptions = () => {
    if (!privacyApi) return;
    const current = privacyApi.currentVisitorConsent();
    modal.querySelectorAll('[data-cookie-option]').forEach((input) => {
      input.checked = current[input.dataset.cookieOption] === 'yes';
    });
  };

  const openModal = (trigger = document.activeElement) => {
    lastFocus = trigger;
    updateOptions();
    modal.hidden = false;
    document.documentElement.classList.add('buskins-cookie-modal-open');
    window.requestAnimationFrame(() => modal.querySelector('[data-cookie-close]')?.focus());
  };

  const saveConsent = (consent) => {
    if (!privacyApi) return;
    privacyApi.setTrackingConsent(consent, () => {
      bannerRoot.hidden = true;
      closeModal();
    });
  };

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error || !window.Shopify.customerPrivacy) return;
      privacyApi = window.Shopify.customerPrivacy;
      bannerRoot.hidden = !privacyApi.shouldShowBanner();
    }
  );

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (target.closest('[data-cookie-accept]')) {
      saveConsent({ preferences: true, analytics: true, marketing: true });
      return;
    }

    if (target.closest('[data-cookie-reject]')) {
      saveConsent({ preferences: false, analytics: false, marketing: false });
      return;
    }

    const manage = target.closest('[data-cookie-manage], [data-cookie-preferences-open]');
    if (manage) {
      event.preventDefault();
      openModal(manage);
      return;
    }

    if (target.closest('[data-cookie-close]')) {
      closeModal();
      return;
    }

    if (target.closest('[data-cookie-save]')) {
      const consent = {};
      modal.querySelectorAll('[data-cookie-option]').forEach((input) => {
        consent[input.dataset.cookieOption] = input.checked;
      });
      saveConsent(consent);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden || event.key !== 'Escape') return;
    event.preventDefault();
    closeModal();
  });
})();
